import { IPresidentDTO } from 'DTOModels/presidentDTO';

export enum ModalMode {
    Edit = 'Edit',
    Create = 'Create',
}

export interface IEditExPresidentModalProps {
    modalVisibility: boolean;
    close: () => void;
    mode?: ModalMode;
    item?: IPresidentDTO;
    updateList: () => void;
}

export interface IEditExPresidentForm {
    name?: string;
    mandateStartDate: moment.Moment | null;
    mandateEndDate: moment.Moment | null;
    photo?: any;
}
